<template>
    <editor-field-frame :label="props.label" :hint="props.hint" :control-id="controlId">
        <template #default="{controlId: id, hintId}">
            <!--
                Das Label steht in der Feldhülle. Am Schalter selbst steht nur
                noch die Bedeutung des aktuellen Zustands - das ist für Kunden
                leichter zu lesen als eine wiederholte Feldbezeichnung.
            -->
            <v-switch v-model="value"
                      :id="id"
                      :aria-describedby="hintId"
                      :label="value ? $t('common.answers.yes') : $t('common.answers.no')"
                      color="primary"
                      density="comfortable"
                      hide-details
                      inset />
        </template>
    </editor-field-frame>
</template>

<script setup>
import {computed} from "vue";
import EditorFieldFrame from "./EditorFieldFrame.vue";
import {parseBool} from "../../utils/helpers";
import {mandatory_props, useEditorField, editorControlId} from "../../utils/editorConfigFieldHelpers";

const props = defineProps(mandatory_props);
const {jsonPath, readValue, writeValue} = useEditorField(props);

const controlId = computed(() => editorControlId('bool', jsonPath.value));

/**
 * Historisch stehen dort auch "true"/"1"/"ja" als Text.
 * @see parseBool()
 */
const value = computed({
    get() {
        return parseBool(readValue(jsonPath.value));
    },
    set(v) {
        writeValue(jsonPath.value, parseBool(v));
    }
});
</script>
